import { Option } from '@customTypes';

interface ConvertOptionsProps<T> {
  items?: T[];
  valueKey: keyof T;
  labelKey: keyof T;
}

export const convertToOptions = <T>({ items, valueKey, labelKey }: ConvertOptionsProps<T>): Option[] => {
  return (
    items?.map((item) => ({
      value: item[valueKey] as number | string,
      label: item[labelKey] as string,
    })) ?? []
  );
};
